const ta = {


  // content Management
  nameRequired: "பெயர் அவசியம் தேவை.",
  subjectRequired: "பொருள் அவசியம் தேவை.",
  famePhotoRequired: "புகைப்படத்தை அவசியம் பதிவேற்ற வேண்டும்",
  contentRequired: "உள்ளடக்கத்தை அவசியம் தேவை.",
  designationRequired: "பதவியை அவசியம் தேவை.",
  imageRequired: "படத்தை அவசியம் பதிவேற்ற வேண்டும்",
  readMoreRequired: "மேலும் படிக்க இணைப்பை அவசியம் தேவை.",
  topicNameRequired: "தலைப்பு பெயரை அவசியம் தேவை.",
  // Event Createion
  categoryRequired: "நிகழ்வு வகையை கட்டாயமாக தேர்வு செய்ய வேண்டும்",
  fromDateRequired: "தொடக்க தேதியை கட்டாயமாக தேர்வு செய்ய வேண்டும்",
  toDateRequired: "முடிவு தேதியை கட்டாயமாக தேர்வு செய்ய வேண்டும்",
  fromTimeRequired: "தொடக்க நேரத்தை கட்டாயமாக தேர்வு செய்ய வேண்டும்",
  toTimeRequired: "முடிவு நேரத்தை கட்டாயமாக தேர்வு செய்ய வேண்டும்",
  venueRequired: "நிகழ்வு இடத்தை கட்டாயமாக உள்ளிட வேண்டும்",
  descriptionRequired: "விளக்கத்தை கட்டாயமாக உள்ளிட வேண்டும்",
  sectionRequired: "பிரிவு தேவையானது",
  shiftRequired: "ஷிஃப்ட் தேவையானது",
  subjectRequired: "பாடம் தேவையானது",
  classRequired: "வகுப்பு தேவையானது",
  chapterRequired: "அத்தியாயம் தேவையானது",
  unitRequired: "அலகு தேவையானது",
  examTypeRequired: "தேர்வு வகை தேவையானது",

  //PASSWORD
  oldPasswordRequired: "பழைய கடவுச்சொல்லை கட்டாயமாக உள்ளிட வேண்டும்",
  passworLeastCharacterdRequired: "கடவுச்சொல் குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்",
  newPasswordRequired: "புதிய கடவுச்சொல்லை கட்டாயமாக உள்ளிட வேண்டும்",
  newPasswordifferentCharacterdRequired: "புதிய கடவுச்சொல் பழைய கடவுச்சொல்லிலிருந்து வேறுபட்டதாக இருக்க வேண்டும்",
  confirmPassword: "புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்",
  doNotMatchPassowrd: "கடவுச்சொற்கள் பொருந்தவில்லை",





  //COMMON
  nameRequired: "பெயர் தேவையாகும்.",
  firstNameRequired: "முதல் பெயர் அவசியம் தேவை.",
  lastNameRequired: "கடைசி பெயர் அவசியம் தேவை.",
  emailRequired: "மின்னஞ்சல் அவசியம் தேவை.",
  phoneRequired: "தொலைபேசி எண் அவசியம் தேவை.",
  genderRequired: "பாலினம் அவசியம் தேவை.",
  dobRequired: "பிறந்த தேதி அவசியம் தேவை.",
  firstNamelength:
    "முதல் பெயர் குறைந்தது 3 எழுத்துகளுக்கு மேல் இருக்க வேண்டும்.",

  experienceRequired: "அனுபவம் தேவையாகும்.",
  suggestionRequired: "பரிந்துரை தேவையாகும்.",
  onlyAlphabetsAllowed:
    "எழுத்துக்கள் மற்றும் இடைவெளிகள் மட்டுமே அனுமதிக்கப்படுகின்றன.",

  //PROFILE
  pincodeRequired: "சரியான 6 இலக்க அஞ்சல் குறியீடு அவசியம் தேவை.",
  stateRequired: "மாநிலம் அவசியம் தேவை.",
  districtRequired: "மாவட்டம் அவசியம் தேவை.",
  cityRequired: "நகரம்/ஊர்/கிராமம் அவசியம் தேவை.",
  addressRequired: "முகவரி அவசியம் தேவை.",
  religionRequired: "மதம் அவசியம் தேவை.",
  templeFrequencyRequired: "கோவில் வருகை அடிக்கடி அவசியம் தேவை.",
  languageRequired: "மொழி அவசியம் தேவை.",
  phoneTenDigits: "தொலைபேசி எண் 10 இலக்கமாக இருக்க வேண்டும்.",
  phonestarts: "எண் 0-இல் தொடங்கக்கூடாது.",
  aadharInvalid: "ஆதார் எண் 12 இலக்கமாக இருக்க வேண்டும்.",
  passportInvalid:
    "பாஸ்போர்ட் எண் 1 எழுத்து மற்றும் அதனைத் தொடர்ந்து 7 இலக்கங்களாக இருக்க வேண்டும் (எ.கா., K1234567).",
  firstNameInvalid:
    "முதல் பெயர் எழுத்துகள் மற்றும் இடைவெளிகளையே கொண்டிருக்க வேண்டும்.",
  lastNameInvalid:
    "கடைசி பெயர் எழுத்துகள் மற்றும் இடைவெளிகளையே கொண்டிருக்க வேண்டும்.",

  // PASSWORD
  currentPasswordRequired: "தற்போதைய கடவுச்சொல் அவசியம் தேவை.",
  newPasswordRequired: "புதிய கடவுச்சொல் அவசியம் தேவை.",
  confirmPasswordRequired: "கடைசியாக உள்ள கடவுச்சொல்லை உறுதிப்படுத்தவும்.",
  currentPasswordInvalid:
    "தற்போதைய கடவுச்சொல் குறைந்தது 8 எழுத்துகள் கொண்டதாகவும், ஒரு பெரிய எழுத்து, ஒரு சிறிய எழுத்து, ஒரு எண் மற்றும் ஒரு சிறப்பு எழுத்தை கொண்டதாகவும் இருக்க வேண்டும்.",
  newPasswordInvalid:
    "புதிய கடவுச்சொல் குறைந்தது 8 எழுத்துகள் கொண்டதாகவும், ஒரு பெரிய எழுத்து, ஒரு சிறிய எழுத்து, ஒரு எண் மற்றும் ஒரு சிறப்பு எழுத்தை கொண்டதாகவும் இருக்க வேண்டும்.",
  confirmPasswordInvalid:
    "உறுதிப்படுத்தும் கடவுச்சொல் குறைந்தது 8 எழுத்துகள் கொண்டதாகவும், ஒரு பெரிய எழுத்து, ஒரு சிறிய எழுத்து, ஒரு எண் மற்றும் ஒரு சிறப்பு எழுத்தை கொண்டதாகவும் இருக்க வேண்டும்.",
  passwordsNotMatch:
    "புதிய கடவுச்சொல் மற்றும் உறுதிப்படுத்தும் கடவுச்சொல் பொருந்தவில்லை.",
  emojiNotAllowed: "கடவுச்சொல்லில் எமோஜிகள் அனுமதிக்கப்படவில்லை.",
  incorrectCurrentPassword: "நீங்கள் உள்ளடக்கிய தற்போதைய கடவுச்சொல் தவறானது.",
  sameAsCurrentPassword:
    "புதிய கடவுச்சொல் தற்போதைய கடவுச்சொல்லோடு ஒரேதாக இருக்க முடியாது.",

  //IMAGE
  fileTooLarge: "கோப்பு அளவு 2MB-ஐ விட அதிகமாக இருக்கக்கூடாது.",
  invalidFileType:
    "தவறான கோப்பு வகை. தயவுசெய்து JPG/JPEG அல்லது PNG படத்தைப் பதிவேற்றவும்.",
  imageUploadFailed:
    "படத்தைப் பதிவேற்றம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
};

export default ta;
